import React from 'react';
import styled from 'styled-components';
import { Icon } from './_base';

const FacebookInvertedSVG = styled(Icon).attrs({ viewBox: '0 0 24 24' })`
    width: 1.556em;
`;

function FacebookInvertedIcon({ color = 'currentColor', ...props }) {
    return (
        <FacebookInvertedSVG data-test="icon-facebook-inverted" {...props}>
            <path
                d="M16.466 24v-9.32h3.06l.458-3.632h-3.518v-2.32c0-1.051.286-1.768 1.76-1.768h1.882V3.71c-.325-.044-1.442-.142-2.741-.142-2.713 0-4.57 1.692-4.57 4.8v2.68H9.73v3.632h3.067V24H1.325A1.325 1.325 0 0 1 0 22.675V1.325C0 .593.593 0 1.325 0h21.35C23.407 0 24 .593 24 1.325v21.35c0 .732-.593 1.325-1.325 1.325h-6.209z"
                fill={color}
                fillRule="nonzero"
            />
        </FacebookInvertedSVG>
    );
}

export { FacebookInvertedIcon as default, FacebookInvertedIcon };
